"use strict";

canopyPublic.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	$stateProvider.state("public.depot", {
		url: "/depot?guestUUID",
		controller: "DepotController",
		templateUrl: Luma.paths.context + "/system/mantle/components/canopyPublic/states/depot/depot.template.html"
	});
}]);
